import { openDialog } from "./consent-manager/container";

let Glob = createGlob();

export function enableOpenDialog() {
  Glob.consentManager.openConsentManager = openDialog;
}

function createGlob() {
  let globalObject = {};

  // https://www.gatsbyjs.org/docs/debugging-html-builds/#how-to-check-if-window-is-defined
  if (typeof window !== "undefined") {
    globalObject = window;
  }

  globalObject.consentManager = globalObject.consentManager || {};

  return globalObject;
}

export function reset() {
  Glob = createGlob();
}
